import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AdminDirectSaleEntity,
  ApiDirectSalesListingParams,
  ApiGetDirectSaleStateTransitionsParams,
  ApiGetDirectSalesParams,
  ApproveDirectSaleBodyDto,
  BackendErrorEntity,
  BroadcastDirectSaleSellerProposalBodyDto,
  CreateDirectSaleBodyDto,
  DirectSaleEntity,
  DirectSaleItemEntity,
  DirectSalesListingResponseDto,
  GetDirectSaleStateTransitionsResponseDto,
  GetDirectSalesResponseDto,
  GetRelistChainResponseDto,
  PreventDirectSaleAutoGoLiveBodyDto,
  ReduceDirectSalePriceBodyDto,
  RequestDirectSalePriceBodyDto,
  SalesBrandListingResponseDto,
  SalesModelListingResponseDto,
  ScheduleDirectSaleBodyDto,
  SetDirectSaleExpiresAtBodyDto,
  SetDirectSaleStateBodyDto,
  UpdateDirectSaleBodyDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiBroadcastSellerProposal = (
    directSaleId: MaybeRef<string | undefined | null>,
    broadcastDirectSaleSellerProposalBodyDto: MaybeRef<BroadcastDirectSaleSellerProposalBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
broadcastDirectSaleSellerProposalBodyDto = unref(broadcastDirectSaleSellerProposalBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/directSales/${directSaleId}/broadcastSellerProposal`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: broadcastDirectSaleSellerProposalBodyDto
    },
      options);
    }
  


export const getApiBroadcastSellerProposalMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiBroadcastSellerProposal>>, TError,{directSaleId: string;data: BodyType<BroadcastDirectSaleSellerProposalBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiBroadcastSellerProposal>>, TError,{directSaleId: string;data: BodyType<BroadcastDirectSaleSellerProposalBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiBroadcastSellerProposal>>, {directSaleId: string;data: BodyType<BroadcastDirectSaleSellerProposalBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiBroadcastSellerProposal(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiBroadcastSellerProposalMutationResult = NonNullable<Awaited<ReturnType<typeof apiBroadcastSellerProposal>>>
    export type ApiBroadcastSellerProposalMutationBody = BodyType<BroadcastDirectSaleSellerProposalBodyDto>
    export type ApiBroadcastSellerProposalMutationError = ErrorType<BackendErrorEntity>

    export const useApiBroadcastSellerProposal = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiBroadcastSellerProposal>>, TError,{directSaleId: string;data: BodyType<BroadcastDirectSaleSellerProposalBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiBroadcastSellerProposal>>,
        TError,
        {directSaleId: string;data: BodyType<BroadcastDirectSaleSellerProposalBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiBroadcastSellerProposalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDirectSalesListing = (
    params?: MaybeRef<ApiDirectSalesListingParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<DirectSalesListingResponseDto>(
      {url: `/directSales/listing`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiDirectSalesListingQueryKey = (params?: MaybeRef<ApiDirectSalesListingParams>,) => {
    return ['directSales','listing', ...(params ? [params]: [])] as const;
    }

    
export const getApiDirectSalesListingQueryOptions = <TData = Awaited<ReturnType<typeof apiDirectSalesListing>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiDirectSalesListingParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListing>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiDirectSalesListingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDirectSalesListing>>> = () => apiDirectSalesListing(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListing>>, TError, TData> 
}

export type ApiDirectSalesListingQueryResult = NonNullable<Awaited<ReturnType<typeof apiDirectSalesListing>>>
export type ApiDirectSalesListingQueryError = ErrorType<BackendErrorEntity>



export function useApiDirectSalesListing<TData = Awaited<ReturnType<typeof apiDirectSalesListing>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiDirectSalesListingParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListing>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiDirectSalesListingQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiDirectSalesListingModels = (
    brandId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      brandId = unref(brandId);
      
      return fetchApiInstance<SalesModelListingResponseDto>(
      {url: `/directSales/brand/${brandId}`, method: 'GET'
    },
      options);
    }
  

export const getApiDirectSalesListingModelsQueryKey = (brandId: MaybeRef<string | undefined | null>,) => {
    return ['directSales','brand',brandId] as const;
    }

    
export const getApiDirectSalesListingModelsQueryOptions = <TData = Awaited<ReturnType<typeof apiDirectSalesListingModels>>, TError = ErrorType<BackendErrorEntity>>(brandId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListingModels>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiDirectSalesListingModelsQueryKey(brandId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDirectSalesListingModels>>> = () => apiDirectSalesListingModels(brandId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(brandId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListingModels>>, TError, TData> 
}

export type ApiDirectSalesListingModelsQueryResult = NonNullable<Awaited<ReturnType<typeof apiDirectSalesListingModels>>>
export type ApiDirectSalesListingModelsQueryError = ErrorType<BackendErrorEntity>



export function useApiDirectSalesListingModels<TData = Awaited<ReturnType<typeof apiDirectSalesListingModels>>, TError = ErrorType<BackendErrorEntity>>(
 brandId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListingModels>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiDirectSalesListingModelsQueryOptions(brandId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiDirectSalesListingBrands = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<SalesBrandListingResponseDto>(
      {url: `/directSales/brands`, method: 'GET'
    },
      options);
    }
  

export const getApiDirectSalesListingBrandsQueryKey = () => {
    return ['directSales','brands'] as const;
    }

    
export const getApiDirectSalesListingBrandsQueryOptions = <TData = Awaited<ReturnType<typeof apiDirectSalesListingBrands>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListingBrands>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiDirectSalesListingBrandsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDirectSalesListingBrands>>> = () => apiDirectSalesListingBrands(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListingBrands>>, TError, TData> 
}

export type ApiDirectSalesListingBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof apiDirectSalesListingBrands>>>
export type ApiDirectSalesListingBrandsQueryError = ErrorType<BackendErrorEntity>



export function useApiDirectSalesListingBrands<TData = Awaited<ReturnType<typeof apiDirectSalesListingBrands>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSalesListingBrands>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiDirectSalesListingBrandsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiDirectSaleDetail = (
    directSaleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
      
      return fetchApiInstance<DirectSaleItemEntity>(
      {url: `/directSales/${directSaleId}/detail`, method: 'GET'
    },
      options);
    }
  

export const getApiDirectSaleDetailQueryKey = (directSaleId: MaybeRef<string | undefined | null>,) => {
    return ['directSales',directSaleId,'detail'] as const;
    }

    
export const getApiDirectSaleDetailQueryOptions = <TData = Awaited<ReturnType<typeof apiDirectSaleDetail>>, TError = ErrorType<BackendErrorEntity>>(directSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSaleDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiDirectSaleDetailQueryKey(directSaleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDirectSaleDetail>>> = () => apiDirectSaleDetail(directSaleId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(directSaleId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDirectSaleDetail>>, TError, TData> 
}

export type ApiDirectSaleDetailQueryResult = NonNullable<Awaited<ReturnType<typeof apiDirectSaleDetail>>>
export type ApiDirectSaleDetailQueryError = ErrorType<BackendErrorEntity>



export function useApiDirectSaleDetail<TData = Awaited<ReturnType<typeof apiDirectSaleDetail>>, TError = ErrorType<BackendErrorEntity>>(
 directSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiDirectSaleDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiDirectSaleDetailQueryOptions(directSaleId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiApproveDirectSale = (
    directSaleId: MaybeRef<string | undefined | null>,
    approveDirectSaleBodyDto: MaybeRef<ApproveDirectSaleBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
approveDirectSaleBodyDto = unref(approveDirectSaleBodyDto);
      
      return fetchApiInstance<DirectSaleItemEntity>(
      {url: `/directSales/${directSaleId}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveDirectSaleBodyDto
    },
      options);
    }
  


export const getApiApproveDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiApproveDirectSale>>, TError,{directSaleId: string;data: BodyType<ApproveDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiApproveDirectSale>>, TError,{directSaleId: string;data: BodyType<ApproveDirectSaleBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiApproveDirectSale>>, {directSaleId: string;data: BodyType<ApproveDirectSaleBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiApproveDirectSale(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiApproveDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiApproveDirectSale>>>
    export type ApiApproveDirectSaleMutationBody = BodyType<ApproveDirectSaleBodyDto>
    export type ApiApproveDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiApproveDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiApproveDirectSale>>, TError,{directSaleId: string;data: BodyType<ApproveDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiApproveDirectSale>>,
        TError,
        {directSaleId: string;data: BodyType<ApproveDirectSaleBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiApproveDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetDirectSaleStateTransitions = (
    params: MaybeRef<ApiGetDirectSaleStateTransitionsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetDirectSaleStateTransitionsResponseDto>(
      {url: `/directSales/getStateTransitions`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetDirectSaleStateTransitionsQueryKey = (params: MaybeRef<ApiGetDirectSaleStateTransitionsParams>,) => {
    return ['directSales','getStateTransitions', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetDirectSaleStateTransitionsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiGetDirectSaleStateTransitionsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetDirectSaleStateTransitionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>> = () => apiGetDirectSaleStateTransitions(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>, TError, TData> 
}

export type ApiGetDirectSaleStateTransitionsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>>
export type ApiGetDirectSaleStateTransitionsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetDirectSaleStateTransitions<TData = Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiGetDirectSaleStateTransitionsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSaleStateTransitions>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetDirectSaleStateTransitionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiCreateDirectSale = (
    createDirectSaleBodyDto: MaybeRef<CreateDirectSaleBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      createDirectSaleBodyDto = unref(createDirectSaleBodyDto);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDirectSaleBodyDto
    },
      options);
    }
  


export const getApiCreateDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateDirectSale>>, TError,{data: BodyType<CreateDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCreateDirectSale>>, TError,{data: BodyType<CreateDirectSaleBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCreateDirectSale>>, {data: BodyType<CreateDirectSaleBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiCreateDirectSale(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCreateDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiCreateDirectSale>>>
    export type ApiCreateDirectSaleMutationBody = BodyType<CreateDirectSaleBodyDto>
    export type ApiCreateDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiCreateDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateDirectSale>>, TError,{data: BodyType<CreateDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCreateDirectSale>>,
        TError,
        {data: BodyType<CreateDirectSaleBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiCreateDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetDirectSales = (
    params?: MaybeRef<ApiGetDirectSalesParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetDirectSalesResponseDto>(
      {url: `/directSales`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetDirectSalesQueryKey = (params?: MaybeRef<ApiGetDirectSalesParams>,) => {
    return ['directSales', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetDirectSalesQueryOptions = <TData = Awaited<ReturnType<typeof apiGetDirectSales>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetDirectSalesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSales>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetDirectSalesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetDirectSales>>> = () => apiGetDirectSales(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSales>>, TError, TData> 
}

export type ApiGetDirectSalesQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetDirectSales>>>
export type ApiGetDirectSalesQueryError = ErrorType<BackendErrorEntity>



export function useApiGetDirectSales<TData = Awaited<ReturnType<typeof apiGetDirectSales>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetDirectSalesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSales>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetDirectSalesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUpdateDirectSale = (
    directSaleId: MaybeRef<string | undefined | null>,
    updateDirectSaleBodyDto: MaybeRef<UpdateDirectSaleBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
updateDirectSaleBodyDto = unref(updateDirectSaleBodyDto);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/${directSaleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDirectSaleBodyDto
    },
      options);
    }
  


export const getApiUpdateDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateDirectSale>>, TError,{directSaleId: string;data: BodyType<UpdateDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateDirectSale>>, TError,{directSaleId: string;data: BodyType<UpdateDirectSaleBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateDirectSale>>, {directSaleId: string;data: BodyType<UpdateDirectSaleBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiUpdateDirectSale(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateDirectSale>>>
    export type ApiUpdateDirectSaleMutationBody = BodyType<UpdateDirectSaleBodyDto>
    export type ApiUpdateDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateDirectSale>>, TError,{directSaleId: string;data: BodyType<UpdateDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateDirectSale>>,
        TError,
        {directSaleId: string;data: BodyType<UpdateDirectSaleBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetDirectSale = (
    directSaleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
      
      return fetchApiInstance<AdminDirectSaleEntity>(
      {url: `/directSales/${directSaleId}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetDirectSaleQueryKey = (directSaleId: MaybeRef<string | undefined | null>,) => {
    return ['directSales',directSaleId] as const;
    }

    
export const getApiGetDirectSaleQueryOptions = <TData = Awaited<ReturnType<typeof apiGetDirectSale>>, TError = ErrorType<BackendErrorEntity>>(directSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSale>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetDirectSaleQueryKey(directSaleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetDirectSale>>> = () => apiGetDirectSale(directSaleId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(directSaleId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSale>>, TError, TData> 
}

export type ApiGetDirectSaleQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetDirectSale>>>
export type ApiGetDirectSaleQueryError = ErrorType<BackendErrorEntity>



export function useApiGetDirectSale<TData = Awaited<ReturnType<typeof apiGetDirectSale>>, TError = ErrorType<BackendErrorEntity>>(
 directSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSale>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetDirectSaleQueryOptions(directSaleId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiSetDirectSaleExpiresAt = (
    directSaleId: MaybeRef<string | undefined | null>,
    setDirectSaleExpiresAtBodyDto: MaybeRef<SetDirectSaleExpiresAtBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
setDirectSaleExpiresAtBodyDto = unref(setDirectSaleExpiresAtBodyDto);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/${directSaleId}/setExpiresAt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setDirectSaleExpiresAtBodyDto
    },
      options);
    }
  


export const getApiSetDirectSaleExpiresAtMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetDirectSaleExpiresAt>>, TError,{directSaleId: string;data: BodyType<SetDirectSaleExpiresAtBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSetDirectSaleExpiresAt>>, TError,{directSaleId: string;data: BodyType<SetDirectSaleExpiresAtBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSetDirectSaleExpiresAt>>, {directSaleId: string;data: BodyType<SetDirectSaleExpiresAtBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiSetDirectSaleExpiresAt(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSetDirectSaleExpiresAtMutationResult = NonNullable<Awaited<ReturnType<typeof apiSetDirectSaleExpiresAt>>>
    export type ApiSetDirectSaleExpiresAtMutationBody = BodyType<SetDirectSaleExpiresAtBodyDto>
    export type ApiSetDirectSaleExpiresAtMutationError = ErrorType<BackendErrorEntity>

    export const useApiSetDirectSaleExpiresAt = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetDirectSaleExpiresAt>>, TError,{directSaleId: string;data: BodyType<SetDirectSaleExpiresAtBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSetDirectSaleExpiresAt>>,
        TError,
        {directSaleId: string;data: BodyType<SetDirectSaleExpiresAtBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSetDirectSaleExpiresAtMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiRelistAuctionAsDirectSale = (
    auctionId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      auctionId = unref(auctionId);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/relistFromAuction/${auctionId}`, method: 'POST'
    },
      options);
    }
  


export const getApiRelistAuctionAsDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRelistAuctionAsDirectSale>>, TError,{auctionId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRelistAuctionAsDirectSale>>, TError,{auctionId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRelistAuctionAsDirectSale>>, {auctionId: string}> = (props) => {
          const {auctionId} = props ?? {};

          return  apiRelistAuctionAsDirectSale(auctionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRelistAuctionAsDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiRelistAuctionAsDirectSale>>>
    
    export type ApiRelistAuctionAsDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiRelistAuctionAsDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRelistAuctionAsDirectSale>>, TError,{auctionId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRelistAuctionAsDirectSale>>,
        TError,
        {auctionId: string},
        TContext
      > => {

      const mutationOptions = getApiRelistAuctionAsDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetDirectSaleRelists = (
    directSaleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
      
      return fetchApiInstance<GetRelistChainResponseDto>(
      {url: `/directSales/${directSaleId}/relists`, method: 'GET'
    },
      options);
    }
  

export const getApiGetDirectSaleRelistsQueryKey = (directSaleId: MaybeRef<string | undefined | null>,) => {
    return ['directSales',directSaleId,'relists'] as const;
    }

    
export const getApiGetDirectSaleRelistsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetDirectSaleRelists>>, TError = ErrorType<BackendErrorEntity>>(directSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSaleRelists>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetDirectSaleRelistsQueryKey(directSaleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetDirectSaleRelists>>> = () => apiGetDirectSaleRelists(directSaleId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(directSaleId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSaleRelists>>, TError, TData> 
}

export type ApiGetDirectSaleRelistsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetDirectSaleRelists>>>
export type ApiGetDirectSaleRelistsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetDirectSaleRelists<TData = Awaited<ReturnType<typeof apiGetDirectSaleRelists>>, TError = ErrorType<BackendErrorEntity>>(
 directSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSaleRelists>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetDirectSaleRelistsQueryOptions(directSaleId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiScheduleDirectSale = (
    directSaleId: MaybeRef<string | undefined | null>,
    scheduleDirectSaleBodyDto: MaybeRef<ScheduleDirectSaleBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
scheduleDirectSaleBodyDto = unref(scheduleDirectSaleBodyDto);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/${directSaleId}/schedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleDirectSaleBodyDto
    },
      options);
    }
  


export const getApiScheduleDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiScheduleDirectSale>>, TError,{directSaleId: string;data: BodyType<ScheduleDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiScheduleDirectSale>>, TError,{directSaleId: string;data: BodyType<ScheduleDirectSaleBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiScheduleDirectSale>>, {directSaleId: string;data: BodyType<ScheduleDirectSaleBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiScheduleDirectSale(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiScheduleDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiScheduleDirectSale>>>
    export type ApiScheduleDirectSaleMutationBody = BodyType<ScheduleDirectSaleBodyDto>
    export type ApiScheduleDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiScheduleDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiScheduleDirectSale>>, TError,{directSaleId: string;data: BodyType<ScheduleDirectSaleBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiScheduleDirectSale>>,
        TError,
        {directSaleId: string;data: BodyType<ScheduleDirectSaleBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiScheduleDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiPreventDirectSaleAutoGoLive = (
    directSaleId: MaybeRef<string | undefined | null>,
    preventDirectSaleAutoGoLiveBodyDto: MaybeRef<PreventDirectSaleAutoGoLiveBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
preventDirectSaleAutoGoLiveBodyDto = unref(preventDirectSaleAutoGoLiveBodyDto);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/${directSaleId}/preventAutoGoLive`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: preventDirectSaleAutoGoLiveBodyDto
    },
      options);
    }
  


export const getApiPreventDirectSaleAutoGoLiveMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPreventDirectSaleAutoGoLive>>, TError,{directSaleId: string;data: BodyType<PreventDirectSaleAutoGoLiveBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPreventDirectSaleAutoGoLive>>, TError,{directSaleId: string;data: BodyType<PreventDirectSaleAutoGoLiveBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPreventDirectSaleAutoGoLive>>, {directSaleId: string;data: BodyType<PreventDirectSaleAutoGoLiveBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiPreventDirectSaleAutoGoLive(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPreventDirectSaleAutoGoLiveMutationResult = NonNullable<Awaited<ReturnType<typeof apiPreventDirectSaleAutoGoLive>>>
    export type ApiPreventDirectSaleAutoGoLiveMutationBody = BodyType<PreventDirectSaleAutoGoLiveBodyDto>
    export type ApiPreventDirectSaleAutoGoLiveMutationError = ErrorType<BackendErrorEntity>

    export const useApiPreventDirectSaleAutoGoLive = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPreventDirectSaleAutoGoLive>>, TError,{directSaleId: string;data: BodyType<PreventDirectSaleAutoGoLiveBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPreventDirectSaleAutoGoLive>>,
        TError,
        {directSaleId: string;data: BodyType<PreventDirectSaleAutoGoLiveBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPreventDirectSaleAutoGoLiveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiReducePrice = (
    directSaleId: MaybeRef<string | undefined | null>,
    reduceDirectSalePriceBodyDto: MaybeRef<ReduceDirectSalePriceBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
reduceDirectSalePriceBodyDto = unref(reduceDirectSalePriceBodyDto);
      
      return fetchApiInstance<DirectSaleItemEntity>(
      {url: `/directSales/${directSaleId}/reducePrice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reduceDirectSalePriceBodyDto
    },
      options);
    }
  


export const getApiReducePriceMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiReducePrice>>, TError,{directSaleId: string;data: BodyType<ReduceDirectSalePriceBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiReducePrice>>, TError,{directSaleId: string;data: BodyType<ReduceDirectSalePriceBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiReducePrice>>, {directSaleId: string;data: BodyType<ReduceDirectSalePriceBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiReducePrice(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiReducePriceMutationResult = NonNullable<Awaited<ReturnType<typeof apiReducePrice>>>
    export type ApiReducePriceMutationBody = BodyType<ReduceDirectSalePriceBodyDto>
    export type ApiReducePriceMutationError = ErrorType<BackendErrorEntity>

    export const useApiReducePrice = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiReducePrice>>, TError,{directSaleId: string;data: BodyType<ReduceDirectSalePriceBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiReducePrice>>,
        TError,
        {directSaleId: string;data: BodyType<ReduceDirectSalePriceBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiReducePriceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiRelistDirectSale = (
    directSaleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/${directSaleId}/relist`, method: 'POST'
    },
      options);
    }
  


export const getApiRelistDirectSaleMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRelistDirectSale>>, TError,{directSaleId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRelistDirectSale>>, TError,{directSaleId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRelistDirectSale>>, {directSaleId: string}> = (props) => {
          const {directSaleId} = props ?? {};

          return  apiRelistDirectSale(directSaleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRelistDirectSaleMutationResult = NonNullable<Awaited<ReturnType<typeof apiRelistDirectSale>>>
    
    export type ApiRelistDirectSaleMutationError = ErrorType<BackendErrorEntity>

    export const useApiRelistDirectSale = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRelistDirectSale>>, TError,{directSaleId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRelistDirectSale>>,
        TError,
        {directSaleId: string},
        TContext
      > => {

      const mutationOptions = getApiRelistDirectSaleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiRequestDirectSalePrice = (
    directSaleId: MaybeRef<string | undefined | null>,
    requestDirectSalePriceBodyDto: MaybeRef<RequestDirectSalePriceBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
requestDirectSalePriceBodyDto = unref(requestDirectSalePriceBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/directSales/${directSaleId}/priceOnRequest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestDirectSalePriceBodyDto
    },
      options);
    }
  


export const getApiRequestDirectSalePriceMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestDirectSalePrice>>, TError,{directSaleId: string;data: BodyType<RequestDirectSalePriceBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiRequestDirectSalePrice>>, TError,{directSaleId: string;data: BodyType<RequestDirectSalePriceBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiRequestDirectSalePrice>>, {directSaleId: string;data: BodyType<RequestDirectSalePriceBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiRequestDirectSalePrice(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiRequestDirectSalePriceMutationResult = NonNullable<Awaited<ReturnType<typeof apiRequestDirectSalePrice>>>
    export type ApiRequestDirectSalePriceMutationBody = BodyType<RequestDirectSalePriceBodyDto>
    export type ApiRequestDirectSalePriceMutationError = ErrorType<BackendErrorEntity>

    export const useApiRequestDirectSalePrice = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiRequestDirectSalePrice>>, TError,{directSaleId: string;data: BodyType<RequestDirectSalePriceBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiRequestDirectSalePrice>>,
        TError,
        {directSaleId: string;data: BodyType<RequestDirectSalePriceBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiRequestDirectSalePriceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiSetDirectSaleState = (
    directSaleId: MaybeRef<string | undefined | null>,
    setDirectSaleStateBodyDto: MaybeRef<SetDirectSaleStateBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
setDirectSaleStateBodyDto = unref(setDirectSaleStateBodyDto);
      
      return fetchApiInstance<DirectSaleEntity>(
      {url: `/directSales/${directSaleId}/setState`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setDirectSaleStateBodyDto
    },
      options);
    }
  


export const getApiSetDirectSaleStateMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetDirectSaleState>>, TError,{directSaleId: string;data: BodyType<SetDirectSaleStateBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSetDirectSaleState>>, TError,{directSaleId: string;data: BodyType<SetDirectSaleStateBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSetDirectSaleState>>, {directSaleId: string;data: BodyType<SetDirectSaleStateBodyDto>}> = (props) => {
          const {directSaleId,data} = props ?? {};

          return  apiSetDirectSaleState(directSaleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiSetDirectSaleStateMutationResult = NonNullable<Awaited<ReturnType<typeof apiSetDirectSaleState>>>
    export type ApiSetDirectSaleStateMutationBody = BodyType<SetDirectSaleStateBodyDto>
    export type ApiSetDirectSaleStateMutationError = ErrorType<BackendErrorEntity>

    export const useApiSetDirectSaleState = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSetDirectSaleState>>, TError,{directSaleId: string;data: BodyType<SetDirectSaleStateBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiSetDirectSaleState>>,
        TError,
        {directSaleId: string;data: BodyType<SetDirectSaleStateBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiSetDirectSaleStateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    